import { render, staticRenderFns } from "./PurchaseOrderDetailInput.vue?vue&type=template&id=27bc92ca&scoped=true&"
import script from "./PurchaseOrderDetailInput.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderDetailInput.vue?vue&type=style&index=0&id=27bc92ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc92ca",
  null
  
)

export default component.exports